import styled from "styled-components";

import {
  DefaultTitleLargeFactory,
  DefaultParagraphLargeFactory,
  DefaultParagraphMediumFactory,
} from "components/common/Typograph/Typograph.Style";

export const SectionGovernancePrincipleContainer = styled.section(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "40px",
}));

export const SectionGovernancePrincipleTitle = styled.h2(({ theme }) => ({
  ...DefaultTitleLargeFactory({ theme }),
  color: theme.color.neutral["02"],
  fontWeight: "700",
  margin: 0,
}));

export const SectionGovernancePrincipleDescription = styled.p(({ theme }) => ({
  ...DefaultParagraphLargeFactory({ theme }),
  color: theme.color.neutral["02"],
  margin: 0,
}));

export const SectionGovernancePrincipleCard = styled.div(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "20px",

  flex: 1,

  width: "100%",
  padding: "16px",
  marginTop: "5px",
  marginBottom: "5px",

  border: `1px solid ${theme.color.neutral["04"]}`,
  borderRadius: "16px",
  boxShadow: "0 4px 4px 0 rgba(0, 0, 0, 0.25)",

  [theme.breakpoint.lg()]: {
    flexDirection: "column",
    justifyContent: "initial",
  },

  svg: {
    minWidth: "90px",
    color: "#002364",

    [theme.breakpoint.lg()]: {
      minWidth: "auto",
    },
  },
}));

export const SectionGovernancePrincipleCardContent = styled.div(() => ({}));

export const SectionGovernancePrincipleCardTitle = styled.h3(({ theme }) => ({
  ...DefaultParagraphLargeFactory({ theme }),
  wordBreak: "break-all",
  color: theme.color.brandSecondary.light,
  fontWeight: 700,
  margin: 0,
  paddingBottom: "16px",
  borderBottom: `1px solid ${theme.color.neutral["05"]}`,

  [theme.breakpoint.lg()]: {
    textAlign: "center",
  },
}));

export const SectionGovernancePrincipleCardDescription = styled.p(
  ({ theme }) => ({
    color: theme.color.neutral["02"],
    ...DefaultParagraphMediumFactory({ theme }),
  })
);
